import request from './index'

export const vipList = () => {
    return request({
        url: '/entity/vip/list',
        method: 'post',
        data: {

        }
    })
}

export const vipAdd = (vip) => {
    return request({
        url: '/entity/vip/add',
        method: 'post',
        data: vip
    })
}

export const vipChange = (vip) => {
    return request({
        url: '/entity/vip/update',
        method: 'post',
        data: vip
    })
}

export const vipDel = (id) => {
    return request({
        url: '/entity/vip/delete/'+id,
        method: 'post',
    })
}